import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { DOCUMENT, isPlatformServer } from '@angular/common';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
} from '@angular/router';
import { filter, fromEvent, Subscription } from 'rxjs';
import { searchIconSVG } from 'src/app/constants/svgs/search-icon';
import { OpenExternalUrlDialogComponent } from '../../utility/open-external-url-dialog/open-external-url-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { searchIconActiveSVG } from 'src/app/constants/svgs/search-icon-active';
import { islChatbotFlatSVG } from 'src/app/constants/svgs/isl-chatbot-flat';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { UtilsService } from 'src/app/services/utils.service';
import { CallAPIService } from 'src/app/services/call-api.service';
import { HttpClient } from '@angular/common/http';
import { importantUpdatesSVG } from 'src/assets/images/important_updates';
import { darkModeIconSVG } from 'src/app/constants/svgs/dark-mode-icon';
import { lightModeIconSVG } from 'src/app/constants/svgs/light-mode-icon';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  public darkModeIconSVG = darkModeIconSVG;
  public lightModeIconSVG = lightModeIconSVG;
  @Input() importantUpdatesValue: any = false;
  @Output() toggleImportantUpdates = new EventEmitter<any>();
  @Output() getImportantUpdates = new EventEmitter<any>();
  public currentRoute: string | undefined;
  public searchIconSVG = searchIconSVG;
  public isLoginBtnVisible: boolean = true;
  public islChatbotFlatSVG = islChatbotFlatSVG;
  public searchIconActiveSVG = searchIconActiveSVG;
  importantUpdatesSVG = importantUpdatesSVG;
  public search: boolean = false;
  private scrollSubs!: Subscription;
  private drawerOpen: boolean = false;
  darkMode: boolean = false;
  importantUpdates: any[] = [];
  @ViewChild('navTopStrip') navTopStripRef!: ElementRef;
  @ViewChild('sideDrawer') sideDrawerRef!: ElementRef;
  @ViewChild('overlay') overlayRef!: ElementRef;
  public commonBotObj: any = {
    deptName: '',
    disName: '',
    url: '',
    serviceId: '',
  };
  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    @Inject(DOCUMENT) private document:Document,
    private router: Router,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private matDialog: MatDialog,
    private analytics: AngularFireAnalytics,
    public utilService: UtilsService,
    private http: HttpClient,
    private callApiService: CallAPIService
  ) {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          if (
            window.location.href ===
              'https://web.umang.gov.in/landing/dashboard' &&
            localStorage.getItem('userInfo')
          ) {
            this.isLoginBtnVisible = false;
          } else {
            this.isLoginBtnVisible = true;
          }
        }
      });
  }

  ngOnInit() {
    this.onLoad();
  }

  onLoad() {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    this.fetchImportanUpdates();
    const theme = localStorage.getItem('theme');
    if (theme === 'dark') {
      this.darkMode = !this.darkMode;
      this.utilService.setTheme(this.darkMode);
      this.setItemSelected();
    } else {
      this.utilService.setTheme(false);
    }
  }

  overRideDarkTheme(): void {
    if(isPlatformServer(this.platformId)){
      return ;
    }
    const darkButton  = this.document.getElementById('dark-btn')
    if(darkButton){
      (<any>window).toggleDarkMode = ()=>{}
      darkButton.addEventListener('click',()=>{
        this.setTheme()
        this.setItemSelected();
      })
    } 
  }

  setItemSelected(){
    const button = document.getElementById('featureItem-ht-dark');
    button.classList.toggle('feature-active');
    const tickIcon = document.getElementById('tickIcon-ht-dark'); 
    tickIcon.style.display = tickIcon.style.display === 'inline-flex' ? 'none' : 'inline-flex';
  }

  setTheme() {
    this.darkMode = !this.darkMode;
    this.utilService.setTheme(this.darkMode);
  }

  ngAfterViewInit() {
    this.initScrollListener();
    this.overRideDarkTheme();
  }


  fetchImportanUpdates() {
    const res = {
      //       body: {
      // "isError": false,
      //       "success": true,
      //       "code": 200,
      //       "data": [
      //           {
      //               "tag_name": "New Feature",
      //               "tag_color": "#876654",
      //               "title": "UMANG's New Helpline Number 10505",
      //               "body": "Save the number today for the seamless assistance.",
      //               "image_url": "",
      //               "type": "view_only",
      //               "button_enable": false,
      //               "button_title": null,
      //               "button_color": null,
      //               "redirect_type": "internal",
      //               "redirect_url": null,
      //               "action": "",
      //               "updated_at": "2025-01-20T07:05:27.779Z",
      //               "sub_type": "announcement",
      //               "department": null,
      //               "service": null,
      //               "scheme": null
      //           }
      //       ]
      //       }
      body: {
        isError: false,
        success: true,
        code: 200,
        data: [
          {
            tag_name: 'New Feature',
            tag_color: '#876654',
            title: 'New Suggestion Feature',
            body: 'On Search, you will get suggestions, which will make it easier to go to desired departments, services,documents & schemes.',
            image_url: '',
            type: 'clickable',
            button_enable: true,
            button_title: 'Check Here',
            button_color:
              '{"ios":"blue-btn","android":"primary-btn","web":"primary-button"}',
            redirect_type: 'external',
            redirect_url: 'https://web.umang.gov.in/',
            action: 'open',
            updated_at: '2025-02-13T06:34:12.490Z',
            sub_type: 'announcement',
            department: null,
            service: null,
            scheme: null,
          },
          {
            tag_name: 'New Feature',
            tag_color: '#876654',
            title: 'Check the Air Quality Index',
            body: 'Just enable your location to view the AQI',
            image_url: '',
            type: 'view_only',
            button_enable: false,
            button_title: null,
            button_color: null,
            redirect_type: 'internal',
            redirect_url: null,
            action: '',
            updated_at: '2025-02-13T06:34:05.946Z',
            sub_type: 'announcement',
            department: null,
            service: null,
            scheme: null,
          },
          {
            tag_name: 'Revamp of Department',
            tag_color: '#006F24',
            title: 'Check Aadhaar Validity',
            body: 'Check Aadhaar Validity on Umang',
            image_url: '',
            type: 'clickable',
            button_enable: false,
            button_title: null,
            button_color: null,
            redirect_type: 'internal',
            redirect_url: null,
            action: '',
            updated_at: '2025-02-13T06:33:59.922Z',
            sub_type: 'services',
            department: {
              department_id: 17,
              department_url: 'https://web.umang.gov.in/dept/17',
              department_name: 'Aadhaar',
              department_type: null,
              department_logo_url:
                'https://media.umangapp.in/app/ico/service/aadhaar1.png',
            },
            service: {
              url: 'https://web.umang.gov.in/aadhar_new/service/60008',
              service_id: 60008,
              service_name: 'Check Aadhaar Validity',
              service_type: 'T',
            },
            scheme: null,
          },
          {
            tag_name: 'Revamp of Department',
            tag_color: '#006F24',
            title: 'My Pan Revamped !',
            body: 'My Pan is now available with new features on umang.',
            image_url: '',
            type: 'clickable',
            button_enable: false,
            button_title: null,
            button_color: null,
            redirect_type: 'internal',
            redirect_url: null,
            action: '',
            updated_at: '2025-02-13T06:34:21.809Z',
            sub_type: 'departments',
            department: {
              department_id: 42,
              department_url: 'https://web.umang.gov.in/dept/42',
              department_name: 'My PAN',
              department_type: 'T',
              department_logo_url:
                'https://media.umangapp.in/app/ico/service/D_1550124890137panlogomin.png',
            },
            service: null,
            scheme: null,
          },
          {
            tag_name: 'New Scheme',
            tag_color: '#876654',
            title: 'New Scheme',
            body: 'New Scheme',
            image_url: '',
            type: 'clickable',
            button_enable: false,
            button_title: null,
            button_color: null,
            redirect_type: 'internal',
            redirect_url: null,
            action: '',
            updated_at: '2025-02-20T06:30:31.042Z',
            sub_type: 'schemes',
            department: null,
            service: null,
            scheme: {
              slug: 'mkky',
              scheme_name: 'Mukhyamantri Kisaan Kalyaan Yojana',
            },
          },
        ],
      },
    };

    // this.getImportantUpdates.emit(res?.body?.data);

    // this.importantUpdates = res?.body?.data;

    // this.callApiService.getImportantUpdates().subscribe({
    //   next: (resp: any) => {
    //     if (resp?.body?.success && !resp?.body?.isError) {
    //       this.importantUpdates = resp?.body?.data;
    //       this.getImportantUpdates.emit(this.importantUpdates);
    //     }
    //     else this.importantUpdates = [];
    //   }, error: (resp: any) => {
    //   }
    // })

    fetch(
      'https://apigw.umang.gov.in/dept/core/api/dept/v1/important-update?mode=web',
      {
        method: 'GET',
        headers: {
          accept: 'application/json, text/plain, */*',
          data: 'eyJtb2RlIjoid2ViIiwidW1hbmdfaWQiOiIiLCJvbGRfdXNlcl9pZCI6IiIsInBsYXRmb3JtIjoiZG9tZXN0aWMiLCJ0b2tlbiI6IiIsImxhbmciOiJlbiIsImlwX2FkZHJlc3MiOiIiLCJkZXZpY2VfaWQiOiIiLCJ0a24iOiIifQ==',
          'x-api-key': '2qYCUKTEFJ6jSvZVcHv5ZxcauMUMhbO33MoTw940',
        },
      }
    )
      .then((response) => response.json())
      .then((resp) => {
        if (resp?.data && resp?.success && !resp?.isError) {
          this.importantUpdates = resp?.data;
          this.getImportantUpdates.emit(this.importantUpdates);
        } else this.importantUpdates = [];
      })
      .catch((error) => console.error('Error:', error));
  }

  openSearch() {
    // this.matDialog.open(GlobalSearchDialogComponent);
    this.search = !this.search;
  }

  close(event: boolean) {
    this.search = event;
  }

  private initScrollListener() {
    if (isPlatformServer(this.platformId)) {
      return;
    }

    this.scrollSubs = fromEvent(window, 'scroll').subscribe({
      next: () => {
        if (window.scrollY > 10) {
          this.renderer.addClass(this.navTopStripRef.nativeElement, 'd-none');
          return;
        }
        this.renderer.removeClass(this.navTopStripRef.nativeElement, 'd-none');
      },
    });
  }

  openSideDrawer() {
    this.renderer.addClass(
      this.sideDrawerRef?.nativeElement,
      'mobile-drawer-menu--open'
    );
    this.renderer.addClass(this.overlayRef?.nativeElement, 'show');
  }

  closeSideDrawer() {
    this.renderer.removeClass(
      this.sideDrawerRef?.nativeElement,
      'mobile-drawer-menu--open'
    );
    this.renderer.removeClass(this.overlayRef?.nativeElement, 'show');
  }

  openLink(item: any) {
    this.matDialog.open(OpenExternalUrlDialogComponent, { data: item });
  }

  navigateToChatbot() {
    this.analytics.logEvent('isl_event', {
      category: 'ISL Page Click',
      action: 'clicked',
      label: 'isl_page_click',
    });
    this.router.navigateByUrl('/accessibility');
  }

  toggleDrawer() {
    this.drawerOpen = !this.drawerOpen;
    this.toggleImportantUpdates.emit(this.drawerOpen);
    this.analytics.logEvent('important_update_event', {
      category: 'Important_View_Imp_U_Web_Landing',
      action: 'view',
      label: 'Imp_U_Web_Landing',
    });
  }

  ngOnDestroy() {
    this.scrollSubs?.unsubscribe();
  }
}
